export default __webpack_public_path__ + "static/media/mailbluster.50446dd6.png";